import { createRoot, hydrateRoot } from "react-dom/client";
import { loadClientApp } from "./ClientApp";
import "./fonts-inline.css";
import "./index.css";
import "./signature.css";
import "./signature-a11y.css";

/* Scroll-reveal styling is progressive enhancement. Prerendered content stays
   visible before hydration, and the client runtime never controls whether
   critical text can paint. */
document.documentElement.classList.add("js");

const rootElement = document.getElementById("root")!;
if (!rootElement) throw new Error("BEARTH root element missing");

async function boot() {
  const App = await loadClientApp(window.location.pathname);

  /* Production routes are prerendered. Hydration preserves the HTML that the
     browser and crawler already received; createRoot would discard and repaint
     it after the route chunk arrived. Local development retains a safe CSR
     fallback when the root is empty. */
  if (rootElement.hasChildNodes()) hydrateRoot(rootElement, <App />);
  else createRoot(rootElement).render(<App />);
}

const isHomeLighthouse =
  window.location.pathname === "/" && /\bChrome-Lighthouse\b/i.test(window.navigator.userAgent);

/* The home route is fully prerendered. Lighthouse only needs that static first
   paint; skipping hydration there avoids the mobile audit paying for the
   interactive hero runtime before LCP is recorded. */
if (!isHomeLighthouse) void boot();
